// extracted by mini-css-extract-plugin
module.exports = {"closeDrawerButton":"CloseDrawerButton_closeDrawerButton__3RHkP","closeDrawerIcon":"CloseDrawerButton_closeDrawerIcon__2SQt3"};